import { getQueue, getQueueLength } from "../reducers/randomMode";
import { getSavedAlbumsFilters, getSavedAlbums, getSavedAlbumsLength, getSavedAlbumsOrder, getFilteredSavedAlbums, getSavedAlbumsTypeFilter, getSavedAlbumsTextFilter, isSavedAlbumsTextFilterReset } from "../reducers/albumListState";
import { updateLastAddedAlbumTime } from "../utils/localStorageUtils";
import { filterAlbums, saveCurrentSortingOnAlbums, sortSavedAlbums } from "../utils/spotifyUtils";
import { SET_SAVED_ALBUMS_LOADING_PROGRESS } from "./disablingProcessesActions";
import { enqueueRandomAlbum, initializePointedAlbum } from "./randomModeActions";
import { getCurrentAlbumListPageSize } from "../reducers/userSettings";
import { setCurrentAlbumListPageSize } from "./userSettingsActions";
import { ALBUM_SORTINGS } from "../utils/constants/enumConstants";
import { checkContainedArray, checkContainedString } from "../utils/utils";

export const SET_SAVED_ALBUMS = 'SET_SAVED_ALBUMS';
export const SET_FILTERED_SAVED_ALBUMS = 'SET_FILTERED_SAVED_ALBUMS';
export const SET_SAVED_ALBUMS_ORDER = 'SET_SAVED_ALBUMS_ORDER';
export const SET_SAVED_ALBUMS_LAYOUT = 'SET_SAVED_ALBUMS_LAYOUT';
export const RESET_SAVED_ALBUMS = 'RESET_SAVED_ALBUMS';
export const SET_SAVED_ALBUMS_WARNINGS = 'SET_SAVED_ALBUMS_WARNINGS';
export const SET_SAVED_ALBUMS_CURRENT_PAGE = 'SET_SAVED_ALBUMS_CURRENT_PAGE';
export const SET_SAVED_ALBUMS_TYPE_FILTER = 'SET_SAVED_ALBUMS_TYPE_FILTER';
export const SET_SAVED_ALBUMS_TEXT_FILTER = 'SET_SAVED_ALBUMS_TEXT_FILTER';
export const RESET_SAVED_ALBUMS_TEXT_FILTER = 'RESET_SAVED_ALBUMS_TEXT_FILTER';

// #region Actions

export const setSavedAlbums = albums => {
    return (dispatch, getState) => {
        const state = getState();
        const savedAlbums = getSavedAlbums(state);
        const queue = getQueue(state);

        postProcessSavedAlbums(albums, queue);

        dispatch({ type: SET_SAVED_ALBUMS, payload: [...savedAlbums, ...albums]});
    }
}

export const setSortedSavedAlbums = () => {
    return (dispatch, getState) => {
        const state = getState();
        const originalAlbums = getSavedAlbums(state);
        const order = getSavedAlbumsOrder(state);
        
        const sortedAlbums = saveCurrentSortingOnAlbums(sortSavedAlbums(originalAlbums, order), order);

        dispatch({type: SET_SAVED_ALBUMS, payload: sortedAlbums});
        dispatch(setFilteredSavedAlbums());
    }
}

export const setSavedAlbumsOrder = payload => ({ type: SET_SAVED_ALBUMS_ORDER, payload });

export const setSavedAlbumsLayout = layout => {
    return dispatch => {
        dispatch(({ type: SET_SAVED_ALBUMS_LAYOUT, payload: layout }));
        dispatch(setCurrentAlbumListPageSize());
    }
}

export const sortRecentlyPlayedAlbums = lastPlayedAlbum => {
    return (dispatch, getState) => {
        if(!lastPlayedAlbum.sortIndexes)
        {
            return;
        }

        const originIndex = lastPlayedAlbum.sortIndexes.playedRecently;
        const destinationIndex = 0;

        if(originIndex === destinationIndex)
        {
            return;
        }

        const state = getState();
        const savedAlbums = getSavedAlbums(state);
        const order = getSavedAlbumsOrder(state);

        lastPlayedAlbum.sortIndexes.playedRecently = destinationIndex;

        savedAlbums.map((album) => {
            if(album.id === lastPlayedAlbum.id) return album;

            if(album.sortIndexes.playedRecently < destinationIndex || album.sortIndexes.playedRecently >= originIndex)
            {
                return album;
            }

            album.sortIndexes.playedRecently++;
            return album;
        });

        const newSavedAlbums = order !== ALBUM_SORTINGS.playedRecently ? savedAlbums : saveCurrentSortingOnAlbums(sortSavedAlbums(savedAlbums, order), order)

        dispatch({
            type: SET_SAVED_ALBUMS, 
            payload: newSavedAlbums
        });
    }
}

export const updateSavedAlbumsLoadingProgress = totalSavedAlbums => {
    const getLoadingProgress = (currentNumber, totalNumber) => {
        if(totalNumber === 0)
        {
            return 0;
        }
    
        const ratio = currentNumber / totalNumber;
        const roundedRatio = Math.round((ratio + Number.EPSILON) * 100);
    
        return roundedRatio;
    }

    return (dispatch, getState) => {

        const state = getState();
        const savedAlbumsLength = getSavedAlbumsLength(state);
        const loadingProgress = getLoadingProgress(savedAlbumsLength, totalSavedAlbums);

        dispatch({ type: SET_SAVED_ALBUMS_LOADING_PROGRESS, payload: loadingProgress });

        if(loadingProgress === 100)
        {
            dispatch({type: RESET_SAVED_ALBUMS, payload: false});
            dispatch(setSortedSavedAlbums());

            const queueLength = getQueueLength(state);

            if(queueLength === 0)
            {
                dispatch(enqueueRandomAlbum());
                dispatch(initializePointedAlbum());
            }
        }
    }
}

export const resetSavedAlbums = () => {
    return (dispatch) => {
        dispatch(setSavedAlbumWarnings(false, false));
        dispatch(setSavedAlbumsOrder(ALBUM_SORTINGS.playedRecently));
        dispatch(resetSavedAlbumsFilters(false));
        dispatch({ type: SET_SAVED_ALBUMS, payload: []});
        dispatch({ type: SET_SAVED_ALBUMS_LOADING_PROGRESS, payload: 0});
        dispatch({ type: RESET_SAVED_ALBUMS, payload: true });
    }
}

export const setSavedAlbumWarnings = (addedAlbums, removedAlbums) => ({ type: SET_SAVED_ALBUMS_WARNINGS, payload: {addedAlbums, removedAlbums}});

export const setSavedAlbumsCurrentPage = pageIndex => {
    return (dispatch, getState) => {
        const state = getState();
        const savedAlbumsLength = getSavedAlbumsLength(state);
        const albumListPageSize = getCurrentAlbumListPageSize(state);
        const pages = Math.ceil(savedAlbumsLength / albumListPageSize);

        if(pageIndex < 0 || pageIndex >= pages)
        {
            return;
        }

        dispatch({type: SET_SAVED_ALBUMS_CURRENT_PAGE, payload: pageIndex});
    }
};

export const setSavedAlbumsTypeFilter = newTypes => {
    return (dispatch, getState) => {
        const state = getState();
        const currentTypes = getSavedAlbumsTypeFilter(state);

        // If the currentTypes contains the newTypes (and it is not empty), that means that the albums that are already filtered out won't match the new filter either
        // So, the filter operation could be applied only to the filtered albums
        const containedTypeArray = newTypes.length !== 0 && checkContainedArray(currentTypes, newTypes);

        dispatch({type: SET_SAVED_ALBUMS_TYPE_FILTER, payload: newTypes});
        dispatch(setFilteredSavedAlbums(containedTypeArray));
    }
}

export const setSavedAlbumsTextFilter = newTextPattern => {
    return (dispatch, getState) => {
        const state = getState();
        const currentTextPattern = getSavedAlbumsTextFilter(state);
        const isTextPatternReset = isSavedAlbumsTextFilterReset(state);
        const emptyTextPattern = !newTextPattern;

        // If the newTextPattern contains the currentTextPattern, that means that the albums that are already filtered out won't match the new filter either
        // So, the filter operation could be applied only to the filtered albums
        const containedTextPattern = checkContainedString(newTextPattern, currentTextPattern);

        dispatch({type: SET_SAVED_ALBUMS_TEXT_FILTER, payload: newTextPattern});
        dispatch({type: RESET_SAVED_ALBUMS_TEXT_FILTER, payload: emptyTextPattern});

        // In case the text patterns has been reset and the newTextPattern is empty, we avoid to filter the savedAlbums since it would be surely a unneed re-filtering
        if(!emptyTextPattern || !isTextPatternReset) dispatch(setFilteredSavedAlbums(containedTextPattern));
    }
}

export const resetSavedAlbumsFilters = (filter = true) => {
    return dispatch => {
        dispatch({type: SET_SAVED_ALBUMS_TYPE_FILTER, payload: []});
        dispatch({type: SET_SAVED_ALBUMS_TEXT_FILTER, payload: ""});
        dispatch({type: RESET_SAVED_ALBUMS_TEXT_FILTER, payload: true});
        if(filter) dispatch(setFilteredSavedAlbums());
    }
}

const setFilteredSavedAlbums = (filterFilteredAlbums = false) => {
    return (dispatch, getState) => {
        const state = getState();
        const filters = getSavedAlbumsFilters(state);
        const savedAlbums = getSavedAlbums(state);
        const currentFilteredAlbums = getFilteredSavedAlbums(state);

        const newFilteredAlbums = filterAlbums(filterFilteredAlbums ? currentFilteredAlbums : savedAlbums, filters);

        dispatch({type: SET_FILTERED_SAVED_ALBUMS, payload: newFilteredAlbums});
    }
}

// #endregion Actions

// #region Other methods

const postProcessSavedAlbums = (savedAlbums, queue) => {
    const checkIfAlbumIsQueued = (savedAlbum) => {
        if(!queue || queue.length === 0) return;
    
        queue.forEach(queuedAlbum => {
            if(savedAlbum.id === queuedAlbum.id)
            {
                savedAlbum.isQueue = true;
            }
        })
    }
    
    const registerAddedAtTime = (savedAlbum) => {
        updateLastAddedAlbumTime(Date.parse(savedAlbum.addedAt));
    }

    savedAlbums.forEach(savedAlbum => {
        checkIfAlbumIsQueued(savedAlbum, queue);
        registerAddedAtTime(savedAlbum);
    });
}

// #endregion Other methods